import React, { useEffect, useReducer } from 'react';
import { colorHEX2RGB, i18nIntl, validateEmail } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

import ButtonCollection from '../builder/ButtonCollection';
import ColorPicker from '../builder/ColorPicker';
import ImageUploader from '../builder/ImageUploader';
import Input from '../builder/Input';
import EmailField from '../builder/EmailField';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import SectionTitle from '../builder/SectionTitle';
import TextArea from '../builder/TextArea';
import {savePromotion} from './EmailsPlatform'
import Tooltip from '../builder/Tooltip.js';
import Module from '../ui_items/Module.js';
import RichEditor from '../builder/RichEditor.js';

const EmailSettings = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const in_floating = props?.in_floating ?? false;
	
	const fields_to_save = ['email_claim_notification',
							'email_fromname',
							'email_replyto',
							'email_signature',
							'email_disclaimer',
							'email_top_image',
							'full_email_top_image',
							'email_bottom_image',
							'full_email_bottom_image',
							'email_colors']

	const _p = props.promotion?.Promotion || props.promotion;
	let _promo = {id:_p.id};
	fields_to_save.map((field,index) => {
		_promo[field] = _p[field];
	});

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type){
			case 'SET_ERRORS':
				return { ...state, errors:action.errors };

			case 'CHANGE_PROMOTION':
				return { ...state, promotion:action.promotion };
			
			default:
				return state;
		}
	}, {
		//Ojo que si prove d'un save extern a EmailSettings, podem necessitar mes camps (OnAir) => save_on_air
		//sino funcionarà amb el promotions/save i especifiquem els camps a guardar
		promotion:(props.onSave != undefined ? (props.promotion?.Promotion || props.promotion) : _promo),
		errors:{},
	});

	const change = (k, v) => {
		if (k=='email_top_image' && v == null) v = "";
		if (k=='email_bottom_image' && v == null) v = "";
		let promotion = state.promotion;
		promotion[k] = v;
		dispatch({ type:'CHANGE_PROMOTION', promotion});
		validateFields(k, v);
	};

	const changeColor = (k, v) => {
		let colors = state.promotion?.email_colors || {};
		colors[k] = v;
		change('email_colors', colors);
	};

	const validateFields = (k, v) => {
		let errors = {};
		if(['email_replyto','email_claim_notification'].includes(k) && v != '' && !validateEmail(v)) errors[k] = i18n("Invalid email format");
		dispatch({ type:'SET_ERRORS', errors});
	};

	const savePromo = (cb) => {
		if(props.onSave != undefined){
			props.onSave(state.promotion,cb)
		} else {
			savePromotion(state.promotion, () =>{
				if(props.dispatch != undefined) props.dispatch({ type:'SAVE_PROMOTION', promotion:state.promotion });
				if(cb != undefined) cb();
			});
		}
	};

	let default_colors = [
		{ type:'layout', text:i18n("Background color"), color:'#E5E7E9' },
		{ type:'body', text:i18n("Body"), color:'#FFFFFF' },
		{ type:'text', text:i18n("Texts"), color:'#363636' },
		{ type:'link', text:i18n("Links"), color:'#1E22AA' },
		{ type:'button', text:i18n("Button"), color:'#1E22AA' },
		{ type:'button_text', text:i18n("Text button"), color:'#FFFFFF' },
	];

	if (props.old_settings) default_colors = default_colors.slice(0,4);

	const email_colors = state.promotion?.email_colors || {};

	if (props.old_settings) {
		for(var key in email_colors) {
			if (email_colors[key].indexOf('#')<0) continue;
			email_colors[key] = colorHEX2RGB(email_colors[key],true);
		}
	}
	
	let agent_email = false;
	if(props.is_claim_settings && props.agent_creator != undefined) {
		agent_email = props.promotion?.email_claim_notification || props.agent_creator.email;
	}

	const Component = (in_floating) ? React.Fragment : Module;
	const from_fulfillment = props?.from_fulfillment ?? false;

	return (
		<Component>
			{(in_floating) && (
				<div class="gui_section_header alone_section_header cleared_header">
					<SectionTitle _class={{other:'in_top'}}>Email settings</SectionTitle>

					<ButtonCollection />
				</div>
			)}

			{(props.premium_fromemail) && (
				<div class="input type text _w70 knk-star yellowIcon">
					<label>{i18n("From email address")}</label>
					<strong class="not_in_top_low button_alike gui_not_in_start_small">{props.premium_fromemail}</strong>
				</div>
			)}

			{(props.is_claim_settings) && (
				<Model model={state.promotion} change={change} errors={state.errors}>
						<EmailField
							_class={{size:70}}
							name="email_claim_notification"
							value={agent_email}
							label_props={{
								tooltip:<Tooltip>Email address that will receive all claim requests.</Tooltip>,
								autocomplete:false,
							}}
						>Email notification</EmailField>
				</Model>	
			)}

			{(!from_fulfillment) && (
				<Model model={state.promotion} change={change} errors={state.errors}>
					
					<Input
						name="email_fromname"
						_class={{size:70}}
					>From name</Input>
					
					<EmailField
						_class={{size:70}}
						name="email_replyto"
						label_props={{
							tooltip:<Tooltip>Email address that will be used in case the user replies directly to the email received. Important: This is not the sender's email address. The sender address 'From email' is not editable and comes with Easypromos domains to minimize spam.</Tooltip>,
							autocomplete:false,
						}}
					>Reply to</EmailField>

					<RichEditor
						//has_emojis={true}
						_class={{size:70, other:'textarea'}}
						name="email_signature"
						//buttons={true}
						//enable_align={true}
					>Email signature</RichEditor>

					<RichEditor
						//has_emojis={true}
						_class={{size:70, other:'textarea'}}
						name="email_disclaimer"
						//buttons={true}
						enable_align={false}
						enable_titles={false}
						label_props={{
							tooltip:<Tooltip position='top'>The text you enter will appear in the email footer. Below this text, a phrase with an unsubscribe link for this promotion will always be displayed. This phrase cannot be removed or edited.</Tooltip>,
						}}
					>Disclaimer</RichEditor>

					<ImageUploader
						name="email_top_image"
						image={state.promotion.full_email_top_image}
						small_input={true}
						_size={{width:600, height:100}}
						_resize={{width:600}}
						_class={{size:70}}
						display_custom_dragging_instructions="Upload the image"
					>Header image</ImageUploader>

					<ImageUploader
						name="email_bottom_image"
						image={state.promotion.full_email_bottom_image}
						small_input={true}
						_size={{width:600, height:80}}
						_resize={{width:600}}
						_class={{size:70}}
						display_custom_dragging_instructions="Upload the image"
					>Footer image</ImageUploader>
				</Model>
			)}

			{(!from_fulfillment) && (	
				<Model model={state.colors} change={changeColor}>
					{default_colors.map((c, i) => {
						const col = (email_colors[c.type] != undefined) ? email_colors[c.type] : c.color;
						return (
							<ColorPicker
								key={`color_${i}`}
								_class={{size:70}}
								name={c.type}
								color={col}
								autotranslate={false}
							>{c.text}</ColorPicker>
						)
					})}
				</Model>
			)}

			<ButtonCollection
				in_floating={in_floating}
				_class={(!in_floating) ? { other:'not_in_top' } : null}
			>
				<SaveButton
					onClick={(e, cb) => savePromo(cb)}
				>Save changes</SaveButton>
			</ButtonCollection>
		</Component>
	)
}

export default injectIntl(EmailSettings);